import React from 'react';
import safeHtml, { escapeHtml } from 'utils/safe-html';

const ResponseArticle = ({ body, title }) => {
    // Even a detached div loads <img> and fires its onerror, so the raw body
    // never reaches innerHTML.
    const tmp = document.createElement('div');
    tmp.innerHTML = safeHtml(body);

    // Replace specific HTML tags with newlines or remove unwanted characters
    tmp.querySelectorAll('p, h1, br, li, b, a').forEach((element) => {
        if (element.tagName === 'P' || element.tagName === 'H1') {
            element.insertAdjacentHTML('beforebegin', '&nbsp;&nbsp;');
        } else if (element.tagName === 'BR' || element.tagName === 'B') {
            element.insertAdjacentHTML('beforebegin', '&nbsp;');
        }
    });

    const cleanedBody = tmp.innerHTML;
    tmp.remove();

    const htmlContentWithTitle = `<h1>${escapeHtml(title)}</h1><br />${safeHtml(
        cleanedBody
    )}`;

    return (
        <div>
            <div dangerouslySetInnerHTML={{ __html: htmlContentWithTitle }} />
        </div>
    );
};

export default ResponseArticle;
